import React, { FC, useCallback } from 'react'
import Error from '@mui/icons-material/Error'
import BaseModal from 'components/BaseModal'
import { Calendar } from './types'
import PointOfContactLines from './components/PointOfContactLines'

interface AlreadyRescheduledModalProps {
  calendar: Calendar
  open: boolean
  setOpen: (open: boolean) => void
}

const AlreadyRescheduledModal: FC<AlreadyRescheduledModalProps> = ({ calendar, open, setOpen }) => {
  const handleClose = useCallback(() => {
    setOpen(false)
  }, [setOpen])

  return (
    <BaseModal open={open} setOpen={setOpen} className="tw:!p-0 tw:!rounded-4xl">
      <div className="tw:bg-yellow-100 tw:flex tw:items-center tw:justify-center tw:py-12">
        <Error className="tw:!size-16 tw:text-yellow-600" />
      </div>
      <div className="tw:p-6 tw:flex tw:flex-col">
        <h2 className="tw:text-lg tw:font-bold">{'Please contact your advisor'}</h2>
        <p className="tw:text-secondary-black">
          {
            'This meeting has already been rescheduled once. You must contact your advisors if you want to reschedule again.'
          }
        </p>
        <div className="tw:mt-4">
          <PointOfContactLines calendar={calendar} />
        </div>
        <button
          type="button"
          className="tw:mt-6 tw:rounded-full tw:p-3 tw:bg-neutrals-200 tw:font-bold"
          onClick={handleClose}
        >
          {'Close'}
        </button>
      </div>
    </BaseModal>
  )
}

export default AlreadyRescheduledModal
